/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The helper to go back to last breadCrumb url
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.2.0
 */

import { openExternalRoute } from '../../../routes/constants/externalRoutes';
import { RoutePath } from '../../../routes/constants/routesConstants';
import appHistory from '../../app/appHistory';
import { IBreadCrumb } from '../breadCrumbsTypes';

export const breadCrumbGoBack = (data?: IBreadCrumb[]) => {
    if (data && data.length > 1) {
        const item: IBreadCrumb = data.slice(-2).shift() as IBreadCrumb;
        if (item.url) {
            item.isUrlExternal ? openExternalRoute(item.url) : appHistory.push(item.url);
        }
    } else {
        appHistory.push(RoutePath.main);
    }
};
